/**
 * Created by roman.kupin on 10/3/2017.
 */

import * as ContestsActions from "../actions/index";

export default function contestsReducer(state = {
    isInitialized: false
}, {type, payload}) {

    switch (type) {
        case ContestsActions.INITIALIZED: {
            return Object.assign({}, state, {isInitialized: payload});
        }
        case ContestsActions.UPCOMING_CONTESTS_FETCH_SUCCESS: {
            return Object.assign({}, state, {upcomingContests: payload});
        }
        case ContestsActions.PAST_CONTESTS_FETCH_SUCCESS: {
            return Object.assign({}, state, {pastContests: payload});
        }
        default: {
            return state;
        }
    }
}